<template>
  <div class="create-account-page overflow-x-hide">
    <div class="container no-padding">
      <div class="row no-margin">
        <ResetPasswordHeader
          :dyn-height="dyn_height"
          :window-height="windowHeight"
        />

        <ResetPasswordContain />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { sessionStorageKeys } from "@/utils/constants";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onBeforeUpdate,
  onMounted,
  ref,
  watch,
} from "vue";
import ResetPasswordHeader from "./resetPassword/resetPasswordHeader.vue";
import ResetPasswordContain from "./resetPassword/resetPasswordContain.vue";

const dyn_height = ref("0");
const windowHeight = ref("");

const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
};

onMounted(() => {
  nextTick(() => {
    window.addEventListener("resize", onResize);
    onResize();
  });
});

onBeforeUnmount(() => {
  sessionStorage.removeItem(sessionStorageKeys.passwordResetToken);
  const bodyElement = document.querySelector("body");

  if (bodyElement && bodyElement.classList.contains("page-opacity")) {
    bodyElement.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
});
</script>

<style lang="scss" scoped>
.create-account-page {
  background: #387dff;
  .form-control:focus {
    box-shadow: none;
  }
  .form-control::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }
  .modal {
    pointer-events: none;
  }
  .modal-backdrop {
    display: none;
  }
  .create-account-modal {
    width: 100%;
    height: 100%;
    pointer-events: none;
    .modal-dialog {
      transition: none;
    }
    .modal-header {
      border: none;
      padding: 10px 10px 0px 10px;
      justify-content: flex-end;
      .close {
        float: right;
        opacity: 1;
        margin-right: 10px;
        margin-top: 10px;
        position: relative;
        padding: 0;
        z-index: 999;
        img {
          width: 19px;
          height: 19px;
        }
      }
    }
    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }
    .modal-body {
      padding: 25px 70px 48px 70px;
      .flex-container {
        position: absolute;
        bottom: 0px;
        height: 100%;
      }
      .modal-body-sec1 {
        color: #0345bd;
        font-size: 26px;
        font-weight: 600;
        line-height: 39px;
      }
      .account-modal-text {
        font-size: 15px;
        color: #231f20;
        line-height: 22px;
        font-weight: 400;
        margin-top: 15px;
      }
      .password-text {
        color: #878787;
        font-size: 12px;
        margin-top: 41px;
      }
      .password-text-sec1 {
        color: #231f20;
      }
      .create-acc-btn {
        margin-top: 38px;
      }
      .input-label-password {
        font-weight: 500;
        font-size: 12px;
        color: #231f20;
        line-height: 18px;
      }
      .password-input {
        border: none;
        font-style: normal;
        font-weight: 300;
        font-size: 22px;
        line-height: 33px;
        color: #0345bd;
        border-left: 1px solid rgba(183, 183, 183, 0.3);
        border-radius: unset;
      }
      .password-group {
        margin-top: 20px;
        label {
          margin-bottom: 14px;
        }
        .password-sec {
          display: flex;
        }
      }
      .password-conditions {
        margin-left: 0px;
        margin-right: 0px;
      }
      .password-left-conditions {
        margin-bottom: 0px;
      }
      .getstarted-button {
        width: 212px;
        height: 45px;
        left: 72px;
        box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
        border-radius: 29.4638px;
        background: #0345bd;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        text-transform: uppercase;
      }
      .create-acc-btn button:disabled {
        color: #ffffff;
        background: #eeeff0;
        border-color: #eeeff0;
      }
      .show-password {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          padding-right: 5px;
        }
        .show-password-label {
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          width: 40px;
        }
        .disabled {
          color: #b7b7b7;
        }
        .enabled {
          color: #0345bd;
        }
      }
    }
    .modal-footer {
      background: linear-gradient(
        180deg,
        rgba(230, 230, 230, 0.38) 0%,
        #ffffff 58.06%
      );
      padding: 26px 70px;
      font-size: 12px;
      .modal-sec6-sec1 {
        line-height: 20.4px;
      }
    }
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .create-account-page {
    .create-account-modal {
      .modal-header {
        .close {
          margin-top: 3px !important;
          img {
            width: 17px;
            height: 17px;
          }
        }
      }
      .modal-body {
        padding: 18px 30px 30px 30px;
        .modal-body-sec1 {
          font-size: 22px;
        }
        .password-group {
          margin-top: 24px !important;
        }
        .getstarted-button {
          font-size: 16px;
          line-height: 24px;
        }
        .password-input {
          font-size: 18px;
          padding-right: 0px;
        }
        .password-input::placeholder {
          font-size: 18px;
        }
        .show-password .show-password-label {
          margin-top: 12px;
        }
        .input-label-password {
          font-size: 12px;
          line-height: 18px;
        }
        .account-modal-text {
          font-size: 15px !important;
          line-height: 22px !important;
          margin-top: 8px !important;
        }
        .password-text {
          margin-top: 22px;
        }
        .create-acc-btn {
          margin-top: 20px;
        }
      }
      .modal-footer {
        padding: 10px 30px;
      }
    }
  }
}

@media (max-height: 500px) {
  .modal {
    padding-top: 50px;
  }
}

@media (min-width: 3840px) {
  .create-account-page {
    .create-account-modal {
      .form-control:focus {
        padding-left: 30px;
        font-size: 38px;
        line-height: 30px;
      }
      .modal-dialog {
        max-width: 1090px !important;
      }
      .modal-body {
        padding: 40px 90px 90px 90px;
      }
      .modal-content {
        border-radius: 15px !important;
      }
      .modal-body-sec1 {
        font-size: 52px !important;
        line-height: 78px !important;
      }
      .account-modal-text {
        font-size: 30px !important;
        line-height: 44px !important;
      }
      .password-group {
        margin-top: 90px !important;
      }
      .input-label-password {
        font-size: 24px !important;
        line-height: 36px !important;
        margin-bottom: 28px !important;
      }
      .show-password {
        padding-left: 20px !important;
        img {
          zoom: 2.2;
        }
      }
      .show-password-label {
        font-size: 24px !important;
        margin-top: 31px !important;
      }
      .close {
        margin-right: 35px !important;
        margin-top: 40px !important;

        img {
          height: 30px !important;
          width: 30px !important;
        }
      }
      .create-acc-btn {
        margin-top: 76px !important;
      }
      .password-input {
        font-size: 44px !important;
        padding-left: 30px;
      }
      .password-input::placeholder {
        font-size: 44px !important;
      }
      .password-text {
        font-size: 24px !important;
        margin-top: 82px !important;
      }
      .modal-sec6-sec1 {
        line-height: 40.8px !important;
      }
      .modal-footer {
        font-size: 20px !important;
        padding: 35px 100px;
      }
      .getstarted-button {
        width: 390px !important;
        height: 90px !important;
        font-size: 30px !important;
        border-radius: 41px !important;
      }
    }
  }
}
</style>
